import React from "react";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { PaymentElement, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { qreq } from "../../shared/qrequest";

const stripePromise = loadStripe('pk_test_51QUbrrLiHNOvHY86ubRYxh8wo3sF65fCNFxj9j6jgmcBUCEfsLjUGd5owyUYOlTG9cZBJoP6e1f0fMC2rKnVjuyA00JDzkQdUB');

class CheckoutSimple extends BaseCom {
    constructor(props) {
        super(props);
        const months = [];
        const years = [];
        for (let n = 1; n <= 12; n++)
            months.push({ id: n, name: n });

        var y = new Date().getFullYear();
        for (let n = y; n <= (y + 20); n++)
            years.push({ id: n, name: n });

        this.state = {
            info: {},
            months: months,
            years: years,
            paymentMethodList: []
        };

    }

    async componentDidMount() {
        try {
            let j = await qreq.postAsync('/api/payment/intent/create', {
                purchaseOrderID: parseInt(this.props.params.poID)
            });
            if (j.item)
                this.setState({ options: { clientSecret: j.item.clientSecret } });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submit = async (e) => {
        e?.preventDefault();

    }

    render() {
        const paymentElementOptions = {
            layout: "accordion",
            disableLink: true
        }
        return (<div className="container-fluid">
            <h1>Checkout</h1>

            {this.state.options && <Elements stripe={stripePromise} options={this.state.options}>
                <form>
                    <PaymentElement id="payment-element" options={paymentElementOptions} />
                    <div className="mt-3">
                        <button type="submit" className="btn btn-primary btn-lg">Pay now</button>
                    </div>
                </form>
            </Elements>}
        </div>);
    }
}

export default withParamsAndNavigate(CheckoutSimple);